import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const LensUpstreamDatasourcesQueryGql: DocumentNode = gql`
query LensUpstreamDatasourcesQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  lenses(filter: { vizportalUrlId: $vizportalUrlId }) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragment
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
